// extracted by mini-css-extract-plugin
export default {"settingsPage":"Layout_settingsPage__Xh+rF"};